import LogService from '@zola-helpers/client/dist/es/util/logService';
import {
  CreditCardView,
  PaymentMethodRequest,
  PaymentMethodView,
  RenewalPlanView,
  UpdateRenewalPlanPaymentRequest,
} from '@zola/svc-marketplace-ts-types';
import * as toastsActions from '@zola/zola-ui/src/actions/toastsV2Actions';

import { AppDispatch, AppThunk } from '~/reducers';
import ApiService from '~/util/apiService';
import { StandardLogFn } from '~/util/logger';

import {
  deletedRenewalPlan,
  receivedRenewalPlan,
  updatedRenewalPlan,
} from './types/vendorCreditRenewalActionTypes';

export const fetchRenewalPlanByStorefront = (
  storefrontUuid: string
): AppThunk<Promise<void | RenewalPlanView>> => {
  return (dispatch: AppDispatch) => {
    return ApiService.get<RenewalPlanView>(
      `/web-marketplace-api/v1/manage/vendor-credits/renewal/storefront/${storefrontUuid}/renewal-plan`
    )
      .then((response) => {
        dispatch(receivedRenewalPlan(response));
        return response;
      })
      .catch((error) => {
        StandardLogFn(error);
        throw error;
      });
  };
};

export const saveNewCreditCard = (
  storefrontUuid: string,
  body: PaymentMethodRequest
): Promise<void | CreditCardView> => {
  return ApiService.post<CreditCardView, PaymentMethodRequest>(
    `/web-marketplace-api/v1/manage/vendor-credits/renewal/storefront/${storefrontUuid}/credit-card`,
    body
  ).catch((error) => {
    StandardLogFn(error);
    throw error;
  });
};

export const updateRenewalPlanPaymentMethod = (
  storefrontUuid: string,
  body: UpdateRenewalPlanPaymentRequest
): AppThunk<Promise<void>> => {
  return (dispatch: AppDispatch) => {
    return ApiService.put<PaymentMethodView, UpdateRenewalPlanPaymentRequest>(
      `/web-marketplace-api/v1/manage/vendor-credits/renewal/storefront/${storefrontUuid}/renewal-plan-payment`,
      body
    )
      .then((payload) => {
        dispatch(updatedRenewalPlan({ payload, storefrontUuid }));
      })
      .catch((error) => {
        const errorId = LogService.log('Marketplace renewal plan payment update error', {
          response: error.response,
        });

        dispatch(
          toastsActions.negative({
            headline: `We could not update your payment method. Please try again.`,
            dismissText: 'Close',
            autoDismissInSeconds: 5,
          })
        );

        throw new Error(`Something went wrong—please try again later. (${errorId})`);
      });
  };
};

export const cancelRenewalPlanByStorefront = (storefrontUuid: string): AppThunk<Promise<void>> => {
  return (dispatch: AppDispatch) => {
    return ApiService.delete<RenewalPlanView>(
      `/web-marketplace-api/v1/manage/vendor-credits/renewal/storefront/${storefrontUuid}/renewal-plan`
    )
      .then((response) => {
        dispatch(deletedRenewalPlan(response));
      })
      .catch((error) => {
        const errorId = LogService.log(`Cancelation error: ${error.message}`, {
          response: error.response,
        });

        StandardLogFn(error);

        throw new Error(`Something went wrong—please try again later. (${errorId})`);
      });
  };
};
